/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when an Entity could not be selected
 * @export
 * @class EntityCouldNotSelectEntityError
 * @extends {Error}
 */
export class EntityCouldNotSelectEntityError extends Error {
  /**
   * Creates an instance of EntityCouldNotSelectEntityError
   * @param {string} message The Error `message`
   * @memberof EntityCouldNotSelectEntityError
   */
  constructor(message) {
    super(message);
    this.name = `EntityCouldNotSelectEntityError`;
  }
}

/**
 * Called when an Entity could not be selected
 * @param {sting} id The `id` of the entity to select
 * @returns {never} never
 */
const throwEntityCouldNotSelectEntityError = (id) => {
  throw new EntityCouldNotSelectEntityError(
    stripIndent(`
    Can not select entity with id: "${id}".
    Entity does not exist.
    Has it been added?
    `),
  );
};

export default throwEntityCouldNotSelectEntityError;
